import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

// お気に入り・検索条件保存ボタンなどで、クリック時にformのmethodを変える
window.addEventListener('DOMContentLoaded', () => {
  let changeMethodBtns = document.querySelectorAll('[data-to-method]');
  const headerRegist = document.querySelector('.header_alert__regist');
  const headerRelese = document.querySelector('.header_alert__relese');
  function headerRegistTimer() { setTimeout(() => { headerRegist.classList.remove('js_down') }, 3000) };
  function headerReleseTimer() { setTimeout(() => { headerRelese.classList.remove('js_down') }, 3000) };

  changeMethodBtns.forEach(changeMethodBtn => {
    changeMethodBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let form      = changeMethodBtn.form;
      let toMethod  = changeMethodBtn.dataset.toMethod;
      let oldMethod = form.method;
      let oldAction = form.action;
      form.method   = toMethod;
      if (changeMethodBtn.formAction) {
        form.action   = changeMethodBtn.formAction;
      }
      form.submit();
      form.method   = oldMethod;
      form.action   = oldAction;

    })
  });

  // 非同期お気に入り
  document.querySelectorAll('.js-asyncFavorite').forEach(asyncFavoriteBtn => {
    asyncFavoriteBtn.addEventListener('click', (e) => {
      let btn  = e.currentTarget;
      if (btn.classList.contains('isActive')) {
        btn.classList.remove('isActive');
        btn.lastChild.textContent = 'お気に入り登録';
        headerRegist.classList.remove('js_down');
        clearTimeout(headerReleseTimer);

        headerRelese.classList.add('js_active');
        headerRelese.classList.add('js_down');
        headerReleseTimer();

      } else {
        btn.classList.add('isActive');
        btn.lastChild.inner
        btn.lastChild.textContent = 'お気に入り';
        headerRelese.classList.remove('js_down');
        clearTimeout(headerRegistTimer);

        headerRegist.classList.add('js_active');
        headerRegist.classList.add('js_down');
        headerRegistTimer();
      }

      let link = btn.formAction;
      axios.post(link)
            .then((res) => {
              if (res.data.success == false) {
                throw new Error('error');
              }



            }).catch((error) => {
              alert("エラーが発生しました。時間を置いてもう一度お試しください。");
            })
    })
  });
})

window.switchSubmit = function(e){
  let clickBtn  = e.currentTarget;
  let actionUrl = clickBtn.dataset.actionUrl;
  let target    = clickBtn.dataset.target;

  document.form.action = actionUrl;
  if (target) {
    document.form.target = target;
  } else {
    document.form.removeAttribute('target');
  }
  document.form.submit();
}